import type { FutyclubConfig } from "./types";
import { Capacitor } from "@capacitor/core";

// Android emulators need to use 10.0.2.2 to access the host machine
// iOS simulators and web browsers use localhost
const getServerUrl = (): string => {
  if (Capacitor.getPlatform() === 'android') {
    return "http://10.0.2.2:3000";
  }
  return "http://localhost:3000";
};

export const config: FutyclubConfig = {
  auth0: {
    domain: "authentication.futyclub.com",
    clientId: "6YVy0HBAv1VV9kLLfUbFehPnDRmqZyMB",
    audience: "https://api.futyclub.com/",
  },
  api: {
    serverUrl: getServerUrl(),
  },
  sentryDsn: "",
  posthogApiKey: "",
};
